export const ConfigDataForModuleConfiguration = [
  {
    id: "name",
    name: "Module",
    isShow: true,
    width: "400px",
    filter: false,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status"],
    permission: {
      ["Update Status"]: {
        id: "Update Status",
        permission: "admin_tools.update_campaign_configuration",
      },
    },
  },
];



export const ConfigDataForRewardProvider = [
  {
    id: "name",
    name: "Provider Name",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "campaign_type",
    name: "Campaign Type",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "image_url",
    name: "Provider Image",
    type: "image",
    isShow: true,
    width: "160px",
    filter: false,
    imageSize: { width: "150px", height: "150px" },

  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit","Delete"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: "admin_tools.update_campaign_configuration",
      },
      ["Delete"]: {
        id: "Delete",
        permission: "admin_tools.update_campaign_configuration",
      },
    },
  },
];



export const ConfigDataForCampaignCategory = [
  {
    id: "name",
    name: "Category Name",
    width: "600px",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit","Delete"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: "admin_tools.update_campaign_configuration",
      },
      ["Delete"]: {
        id: "Delete",
        permission: "admin_tools.update_campaign_configuration",
      },
    },
  },
];



export const ConfigDataForEarningLimitPeriod = [
  {
    id: "label",
    name: "Period",
    isShow: true,
    filter: false,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status"],
    permission: {
      ["Update Status"]: {
        id: "Update Status",
        permission: "admin_tools.update_campaign_configuration",
      },
    },
  },
];



export const ConfigDataForGlobalConfig = [
  {
    id: "max_coupons",
    name: "Max Claim Coupon",
    width: "300px",
    isShow: true,
    filter: false,
  },
  {
    id: "reset_period_month",
    name: "Points Reset Period (Month)",
    width: "300px",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: "admin_tools.update_campaign_configuration",
      },
    },
  },
];
